<div class="summary-div">
  <h2 class="top-margin-3" id="summary-header">Data Summary</h2>
  <div id="summary-data">
    <div class="summary-container">
      <table class="summary-info">
        <tbody>
          <tr>
            <th class="t-head">Created By</th>
            <td class="t-data">{{summaryRecord?.createdBy}}</td>
          </tr>
          <tr>
            <th class="t-head">Created On</th>
            <td class="t-data">{{summaryRecord?.submittedDate | date: 'MM/dd/yyyy'}}</td>
          </tr>
          <tr>
            <th class="t-head">Amount</th>
            <td class="t-data">{{summaryRecord?.amount | currency: 'USD'}}</td>
          </tr>
          <tr>
            <th class="t-head">File Name</th>
            <td class="t-data">
              <span *ngIf="summaryRecord" class="view-excel"
                (click)="downloadAdjFile(summaryRecord);summaryRecord.isClicked=!summaryRecord.isClicked">
                <span *ngIf="!summaryRecord.isClicked" class="k-icon k-i-file-excel k-i-excel"></span>
                <a class="clone-link" *ngIf="!summaryRecord.isClicked">{{summaryRecord?.fileName}}</a>
                <span *ngIf="summaryRecord.isClicked" class="k-icon k-i-loading inner"></span>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
